export interface ITimeSlot {
    id: number,
    day: number,
    startTime: string,
    startTimeRaw: number,
    endTime: string,
    endTimeRaw: number,
    officerId: number,
    overlap: boolean
}